import { expr, MapboxExpr } from "../mapbox";
import { Feature } from "geojson";
import { MapLayer } from "@cartographerio/atlas-map";

function isFeature(layer: MapLayer, feature: Feature): MapboxExpr {
  return layer.primaryKey !== undefined
    ? expr.eql(
        expr.get(layer.primaryKey),
        feature.properties?.[layer.primaryKey]
      )
    : expr.eql(expr.id(), feature.id ?? null);
}

export function selectedFilter(
  layer: MapLayer,
  features: Feature[]
): MapboxExpr {
  return expr.any(...features.map(feature => isFeature(layer, feature)));
}

export function notSelectedFilter(
  layer: MapLayer,
  features: Feature[]
): MapboxExpr {
  return expr.all(
    ...features.map(feature => expr.not(isFeature(layer, feature)))
  );
}

export function featureId(layer: MapLayer, feature: Feature): string | number {
  return layer.primaryKey !== undefined
    ? feature.properties?.[layer.primaryKey]
    : feature.id ?? null;
}
